<template>
    <sidebar-left>
        <slot slot="sidebar-left">
            <SideMenu :SideMenuLinks="sideMenuLinks"></SideMenu>
        </slot>
        <slot slot="main">
            <v-loading :data="loaded" type="global"></v-loading>
            <div class="u-max-700 u-center-block">
                <page-header>
                    <slot slot="title">{{ $t('customer.account.history.title') }}</slot>
                    <slot slot="description">
                        <p>{{ $t('intro.customer_account_history') }}</p>
                    </slot>
                </page-header>

                <section class="c-form-row o-page-bottom-spacing--medium u-center-block">
                    <div v-for="order in CustomerOrders" :key="order.OrderNumber" class="u-margin-bottom">
                        <v-order-line :order="order" :to="`/customer/account/history/detail/${order.Id}`"></v-order-line>
                    </div>
                    <v-empty-state v-if="!CustomerOrders || CustomerOrders.length == 0">
                        <slot slot="title">{{ $t('customer.account.history.no_orders') }}</slot>
                    </v-empty-state>
                </section>
            </div>
        </slot>
    </sidebar-left>
</template>

<script>

    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VSwitch from '@/components/form/Switch'
    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'
    import VOrderLine from '@/components/order/OrderLine'
    import VLoading from '@/components/Loading'
    import VEmptyState from '@/components/EmptyState'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            SideMenu,
            SidebarLeft,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VTargetListSelect,
            VSwitch,
            VOrderLine,
            VLoading,
            VEmptyState
        },
        data() {
            return {
                Validate: {},
                loaded: {}
            }
        },
        created(){
            this.$store.dispatch('getCustomerOrders').then(() => {
                this.loaded = {
                    isLoaded: true
                }
            }).catch(() => {
                this.loaded = {
                    isLoaded: true
                }
                this.$notify({
                    group: 'global',
                    title: 'Er heeft zich een technisch probleem voorgedaan.',
                    type: 'error',
                    duration: 4000
                });
            })
        },
        computed: {
            ...mapGetters({
                CustomerOrders: 'customerOrders'
            }),
            sideMenuLinks() {
                let menu = [
                    {
                        title: 'customer.account.edit.title',
                        route: '/customer/account/edit',
                    }
                ];

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.users.title',
                        route: '/customer/account/users'
                    });
                    menu.push({
                        title: 'customer.account.addresses.title',
                        route: '/customer/account/addresses'
                    });
                }

                if(this.isCustomer || this.isMarketing) {
                    menu.push({
                        title: 'customer.account.history.title',
                        route: '/customer/account/history'
                    });

                    menu.push({
                        title: 'customer.account.backorders.title',
                        route: '/customer/account/backorders'
                    })
                }

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.invoices.title',
                        route: '/customer/account/invoices'
                    });
                }

              return menu;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        },
        methods: { }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/customer/account/History.vue